import React from 'react';

import ReadOnlyInput from '@features/supplier-onboarding/components/ReadOnlyInput';

import { useSupplierInfo } from '@store/reducers/supplier-onboarding/OnboardingReducer';

import { supplierWorkflowSteps } from '@/constants/constant';

const CapacityInformation = ({ setActiveStep }) => {
	const supplierInfo = useSupplierInfo();
	const stepName = 'CAPACITY_INFORMATION';

	const renderKeyCustomers = () => {
		return supplierInfo?.brandResponseList?.map((item, i) => {
			return (
				<React.Fragment key={`brand_response_${item.id}`}>
					<div className={`col-md-6 ${i === 0 ? 'first-key-customer' : ''}`}>
						<ReadOnlyInput
							label={i === 0 ? 'Key Customers' : ''}
							name={`keyCustomer.${i}.brand`}
							value={item?.BrandName}
							stepName={stepName}
						/>
					</div>
					<div className={`col-md-6 pl-1 ${i === 0 ? 'first-key-customer' : ''}`}>
						<ReadOnlyInput
							label={i === 0 ? '.' : ''}
							name={`keyCustomer.${i}.productionVolume`}
							value={item?.productionVolume}
							className="invisible"
							stepName={stepName}
						/>
					</div>
				</React.Fragment>
			);
		});
	};

	return (
		<div className="information-form capacity-Information">
			<h3 className="title weight-700 gray_dark_01">Capacity Information</h3>
			<div className="row">
				<div className="col-md-12">
					<ReadOnlyInput
						label="Production Line"
						name="numberOfLine"
						value={supplierInfo?.numberOfLine}
						stepName={stepName}
					/>
				</div>
				<div className="col-md-12">
					<ReadOnlyInput
						label="Total Employees"
						name="totalEmployee"
						value={supplierInfo?.totalEmployee}
						stepName={stepName}
					/>
				</div>
				<div className="col-md-12">
					<ReadOnlyInput
						label="Male in %"
						name="maleEmployeePercentage"
						value={supplierInfo?.productionCapacity?.maleEmployeePercentage}
						stepName={stepName}
					/>
				</div>
				<div className="col-md-12">
					<ReadOnlyInput
						label="Female in %"
						name="femaleEmployeePercentage"
						value={supplierInfo?.productionCapacity?.femaleEmployeePercentage}
						stepName={stepName}
					/>
				</div>
				<div className="col-md-12">
					<div className="label-group">
						<span className="medium-14 gray_dark_01 mb-2">Knitting Capacity</span>
						<div className="input-group flex-nowrap">
							<div className="input-group-prepend pr-2">
								<span
									className="input-group-text regular-14 gray_dark_05"
									id="addon-wrapping"
								>
									Ton/Month
								</span>
							</div>
							<ReadOnlyInput
								name="knitting"
								value={supplierInfo?.productionCapacity?.knitting}
								stepName={stepName}
							/>
						</div>
					</div>
				</div>
				<div className="col-md-12">
					<div className="label-group">
						<span className="medium-14 gray_dark_01 mb-2">Dyeing Capacity</span>
						<div className="input-group flex-nowrap">
							<div className="input-group-prepend pr-2">
								<span
									className="input-group-text regular-14 gray_dark_05"
									id="addon-wrapping"
								>
									Ton/Month
								</span>
							</div>
							<ReadOnlyInput
								name="dyeing"
								value={supplierInfo?.productionCapacity?.dyeing}
								stepName={stepName}
							/>
						</div>
					</div>
				</div>
				<div className="col-md-12">
					<div className="label-group">
						<span className="medium-14 gray_dark_01 mb-2">Sewing Capacity</span>
						<div className="input-group flex-nowrap">
							<div className="input-group-prepend pr-2">
								<span
									className="input-group-text regular-14 gray_dark_05"
									id="addon-wrapping"
								>
									Pcs/Month
								</span>
							</div>
							<ReadOnlyInput
								name="sewing"
								value={supplierInfo?.productionCapacity?.sewing}
								stepName={stepName}
							/>
						</div>
					</div>
				</div>
				<div className="col-md-12">
					<div className="label-group">
						<span className="medium-14 gray_dark_01 mb-2">Washing Capacity</span>
						<div className="input-group flex-nowrap">
							<div className="input-group-prepend pr-2">
								<span
									className="input-group-text regular-14 gray_dark_05"
									id="addon-wrapping"
								>
									Pcs/Month
								</span>
							</div>
							<ReadOnlyInput
								name="washing"
								value={supplierInfo?.productionCapacity?.washing}
								stepName={stepName}
							/>
						</div>
					</div>
				</div>
				<div className="col-md-12">
					<div className="label-group">
						<span className="medium-14 gray_dark_01 mb-2">Annual Turnover</span>
						<div className="input-group flex-nowrap">
							<div className="input-group-prepend pr-2">
								<span
									className="input-group-text regular-14 gray_dark_05"
									id="addon-wrapping"
								>
									Unit
								</span>
							</div>
							<ReadOnlyInput
								name="sales"
								value={supplierInfo?.productionCapacity?.sales}
								stepName={stepName}
							/>
						</div>
					</div>
				</div>
				{renderKeyCustomers()}
			</div>
			<div className="submit-button">
				<button
					className="button size32 w-100"
					onClick={() => setActiveStep(supplierWorkflowSteps.BANK_INFORMATION)}
				>
					Next
				</button>
			</div>
		</div>
	);
};

export default CapacityInformation;
